export default __webpack_public_path__ + "static/media/face_2_73.aa762c48.png";